// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"3e0d54cac4c5d5eef986","3":"dd9b5cfbdd8c3291a6f2","4":"b3cd660b295084cf2232","5":"9eada9bab0bfa5980365"}[chunkId] + "";
};